/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_2Inputs */

const en_gc_search_guides_gridcraft_online_sections_0_steps_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click inside the spreadsheet before using its keyboard shortcuts. The editor runs in an embedded frame, so keyboard focus matters.`)
};

const zh_gc_search_guides_gridcraft_online_sections_0_steps_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用快捷键前先点击电子表格内部。编辑器运行在嵌入框架中，因此键盘焦点会影响操作。`)
};

/**
* | output |
* | --- |
* | "Click inside the spreadsheet before using its keyboard shortcuts. The editor runs in an embedded frame, so keyboard focus matters." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_0_steps_2 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_0_Steps_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_0_steps_2(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_0_steps_2(inputs)
});
export { gc_search_guides_gridcraft_online_sections_0_steps_2 as "gc.search_guides.gridcraft_online.sections.0.steps.2" }